/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { FormEvent, useState } from 'react';
import { Button, ErrorText, Input, PageHeader, Select } from '@/components/ui';
import { api } from '@/lib/api';

const DICTS = [
  { id: 'expense_category', label: 'Статьи затрат' }, { id: 'document_kind', label: 'Виды документов' }, { id: 'service', label: 'Услуги' },
  { id: 'lead_source', label: 'Источники обращений' }, { id: 'lost_reason', label: 'Причины отказа' },
];

export function DictionariesPage() {
  const qc = useQueryClient();
  const [dict, setDict] = useState(DICTS[0].id);
  const { data } = useQuery({ queryKey: ['dict', dict], queryFn: () => api.get(`/dictionaries/${dict}`) });
  const [name, setName] = useState('');
  const add = useMutation({
    mutationFn: () => api.post(`/dictionaries/${dict}`, { code: `c${Date.now().toString(36)}`, name, sort: (data?.length ?? 0) }),
    onSuccess: () => { setName(''); qc.invalidateQueries({ queryKey: ['dict', dict] }); },
  });
  const toggle = useMutation({
    mutationFn: (i: any) => api.patch(`/dictionaries/${dict}/${i.id}`, { isActive: !i.isActive }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['dict', dict] }),
  });
  const submit = (e: FormEvent) => { e.preventDefault(); if (name.trim()) add.mutate(); };
  return (
    <>
      <PageHeader title="Справочники" actions={<Select value={dict} onChange={(e) => setDict(e.target.value)} options={DICTS.map((d) => ({ value: d.id, label: d.label }))} />} />
      <div className="card max-w-2xl">
        <form onSubmit={submit} className="flex gap-2 border-b border-slate-200 p-3">
          <Input placeholder="Новое значение" value={name} onChange={(e) => setName(e.target.value)} />
          <Button type="submit">Добавить</Button>
        </form>
        <ErrorText error={add.error} />
        <ul className="divide-y divide-slate-100">
          {data?.map((i: any) => (
            <li key={i.id} className="flex items-center justify-between px-3 py-2 text-sm">
              <span className={i.isActive ? '' : 'text-slate-400 line-through'}>{i.name}</span>
              <Button size="sm" variant="ghost" onClick={() => toggle.mutate(i)}>{i.isActive ? 'Скрыть' : 'Вернуть'}</Button>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
